import { Tab, Tabs } from '@mui/material';
import * as React from 'react';
import { PageTitle } from '../../../components/StyledComponents';
import { HeaderContainer } from './StyledComponents';

const Header = (props) => {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const statusTabs = ['Table View', 'Gantt View'];

  const handleTabChange = (event, newValue) => {
    props.setStatus(statusTabs[newValue]);
    setSelectedTab(newValue);
  };

  return (
    <HeaderContainer
      sx={(theme) => ({
        justifyContent: props.hideTitle ? 'flex-end' : 'space-between',
        ...(props.hideTitle && {
          position: 'sticky',
          top: 0,
          zIndex: 10,
          backgroundColor: '#fff',
          ...theme.applyStyles('dark', {
            backgroundColor: '#000',
          }),
        })
      })}
    >
      {!props.hideTitle && <PageTitle>Schedule</PageTitle>}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        aria-label="status tabs"
      >
        {statusTabs.map((tab, index) => (
          <Tab key={`${index}-${tab}`} value={index} label={tab} />
        ))}
      </Tabs>
    </HeaderContainer>
  );
};

export default Header;
